// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener } from "~/lib/signals";
import ContentFull from "~/content.full";
import { _ } from "~/i18n";
import { useScroll } from "~/util/usescroll";
import Scene from "~/scene";

/**
 * Pravy kontent se vsema vychytavkama.
 */
Mapy.TweaksList = class extends ContentFull {
	constructor() {
		super();

		this._contentName = "tweaks";
		this._loading = false;
		this._firstLoad = true;
		this._existMore = true;
		this._nextPage = 1;
		this._binds = {
			createItems: this._createItems.bind(this),
		};
		this._scrollListener = null;

		this._dom = {
			container: node("div", {id:"tweaks-list"}),
			h1: node("h1", { innerHTML: _("tweaksList.title")}),
			list: node("ul", { className: "list" })
		};

		this._dom.container.appendChild(this._dom.h1);
		this._dom.container.appendChild(this._dom.list);

		this._buildCloseButton();

		addListener(this, "width-change-start", "_widthChangeStart");
	}

	_clickClose(e) {
		this.deactivate();
		Mapy.getComponent("history").save();
	}

	_widthChangeStart(e) {
		if (e.data.newWidth < 2) {
			this.deactivate();
		}
	}

	_endScroll() {
		this._scrollListener && this._scrollListener();
		this._scrollListener = null;

		const li = node("li", { className: "end", innerHTML: _("tweaksList.end") });

		this._dom.list.appendChild(li);
	}

	_createItems(items) {
		this._nextPage += 1;

		items.forEach(function(item) {
			var li = node("li", { className: "item" });

			li.insertAdjacentHTML("beforeend", item.content.rendered);

			if (item._embedded
				&& item._embedded['wp:featuredmedia']
				&& item._embedded['wp:featuredmedia'].length
				&& item._embedded['wp:featuredmedia'][0].media_type === "image") {
				var imgCover = node("div", { className: "img-cover"});

				var img = new Image();
				img.src = item._embedded['wp:featuredmedia'][0].source_url;

				imgCover.appendChild(img);

				li.appendChild(imgCover);
			}

			var div = node("div", { className: "rest" });

			var date = node("span", { className: "date"});
			date.innerHTML = Mapy.Util.dateFormat(new Date(item.date), "d. m. yyyy");

			div.appendChild(date);

			li.appendChild(div);

			this._dom.list.appendChild(li);
		}, this);
		/*if (data) {
			var items = data.items;

			items.forEach(function(item) {
				var li = node("li", { className: "item" });

				li.insertAdjacentHTML("beforeend", item.content);

				if (item.imageUrl) {
					var imgCover = node("div", { className: "img-cover"});

					var img = new Image();
					img.src = item.imageUrl;

					imgCover.appendChild(img);

					li.appendChild(imgCover);
				}

				var div = node("div", { className: "rest" });

				var date = node("span", { className: "date"});
				date.innerHTML = Mapy.Util.dateFormat(new Date(item.date), "d. m. yyyy");

				div.appendChild(date);

				li.appendChild(div);

				this._dom.list.appendChild(li);
			}, this);

			if (!data.existsMore) {
				Mapy.getComponent("layout").getScrollNode().removeEventListener("scroll", this, false);
				document.removeEventListener("scroll", this, false);

				var li = node("li", { className: "end", innerHTML: _("tweaksList.end") });

				this._dom.list.appendChild(li);
			}
		}*/


		this._firstLoad = false;
		this._loading = false;
	}

	setState(state) {
		this["tweaks" in state ? "activate" : "deactivate"]();
	}

	getState() {
		return {
			tweaks: 1
		};
	}

	activate() {
		if (this.isActive()) { return this; }

		super.activate();

		if (this._firstLoad) {
			Mapy.Util.getTweaks(this._nextPage).then(this._binds.createItems, this._binds.endScroll);
		}

		this._scrollListener = useScroll({
			onScroll: (isBottom: boolean) => {
				if (isBottom && !this._loading) {
					this._loading = true;
					Mapy.Util.getTweaks(this._nextPage).then(this._binds.createItems, this._binds.endScroll);
				}
			},
		});

		return this;
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		super.deactivate();

		// remove events
		this._scrollListener && this._scrollListener();
		this._scrollListener = null;

		return this;
	}
};
